// src/border-radius.ts
var borderRadius = {
  small: "4px",
  DEFAULT: "8px",
  large: "12px"
};

// src/colors.ts
var colors = {
  default: {
    100: "#ECF2FE",
    200: "#CAE0FC",
    300: "#8DBEF5",
    400: "#2D69F6"
  },
  blue: {
    50: "#ECF2FE",
    100: "#CAE0FC",
    200: "#8DBEF5",
    300: "#2D69F6",
    400: "#0045E5",
    600: "#2D3653",
    700: "#070C50",
    800: "#14142B"
  },
  gray: {
    50: "#F7F7FC",
    100: "#F2F2F2",
    150: "#E0E0E0",
    200: "#D0D5DD",
    300: "#BDBDBD",
    400: "#828282",
    500: "#4F4F4F",
    600: "#333333",
    700: "#344054",
    900: "#101828"
  },
  white: {
    0: "#ffffff"
  },
  green: { 50: "#EEFFF3", 100: "#6FCF97", 200: "#27AE60", 300: "#219653" },
  accent: { 100: "#BB6BD9", 200: "#9B51E0" },
  red: { 50: "#FFF6F8", 100: "#F5C7C7", 200: "#F17E7E", 300: "#EB5757" },
  orange: { 50: "#F5E6D9", 100: "#FFD5AF", 200: "#F5B072", 300: "#F2994A" },
  yellow: { 50: "#FFFBED", 100: "#FEEDB9", 200: "#F5D676", 300: "#F2C94C" },
  purple: { 50: "#F7F1FD", 600: "#9B51E0" }
};

// src/font-family.ts
var fontFamily = {
  sans: ["DM Sans", "sans-serif"]
};

// src/font-size.ts
var fontSize = {
  xs: "0.75rem",
  sm: "0.875rem",
  base: "1rem",
  lg: "1.125rem"
};

// src/font-weight.ts
var fontWeight = {
  regular: "400",
  medium: "500",
  bold: "700"
};

// src/box-shadow.ts
var boxShadow = {
  DEFAULT: "2px 8px 16px 0px rgba(60, 60, 60, 0.12);",
  xs: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  xl: "0px 8px 8px -4px rgba(16, 24, 40, 0.04), 0px 20px 24px -4px rgba(16, 24, 40, 0.10);"
};
export {
  borderRadius,
  boxShadow,
  colors,
  fontFamily,
  fontSize,
  fontWeight
};
